
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cv",
      function () {
        return require("private-next-pages/cv.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cv"])
      });
    }
  